// extracted by mini-css-extract-plugin
export var sliderRange = "_oo-2";
export var sliderRoot = "_oo-0";
export var sliderThumb = "_oo-3";
export var sliderTrack = "_oo-1";